module.exports = __webpack_public_path__ + "0ffbcc0ec471a32a3098a42ae29e65ab.gif";


//////////////////
// WEBPACK FOOTER
// ./img/rage-quit.gif
// module id = 453
// module chunks = 0